import BannerComp from "../components/BannerComp";
import Seo from "../components/Seo";
import { SpecialCardSection } from "../components/SpecialCard";
import { specialties } from "../data/specialties";
import PartnerSliderComp from "../components/PartnerSliderComp";
import { createBreadcrumbSchema } from "../lib/seo";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import ServiceCTASection from "../components/ServiceCTASection";

const seo = {
  title: "About Physicians Success Partners | Healthcare RCM Experts",
  description:
    "Learn about Physicians Success Partners, a trusted healthcare RCM company delivering expert billing, coding, and revenue cycle solutions.",
  keywords:
    "about PSP RCM, medical billing company, healthcare revenue cycle experts, billing support team",
  schema: [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "About Physicians Success Partners",
      url: "https://psprcm.us/about-us/",
      description:
        "Physicians Success Partners (PSP) delivers expert medical billing, Coding denial management, and RCM services across more than 30 healthcare specialties.",
      mainEntity: {
        "@type": "Organization",
        name: "Physicians Success Partners",
        url: "https://psprcm.us/",
        logo: "https://psprcm.us/logo/main-logo.webp",
        description:
          "Physicians Success Partners (PSP) delivers expert medical billing, coding, denial management, and RCM services across more than 30 healthcare specialties.",
        foundingLocation: {
          "@type": "Place",
          address: {
            "@type": "PostalAddress",
            streetAddress: "1616 Westgate Circle",
            addressLocality: "Brentwood",
            addressRegion: "TN",
            postalCode: "37027",
            addressCountry: "USA",
          },
        },
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+1 6155536787",
          contactType: "customer service",
          email: "info@psprcm.us",
        },
        sameAs: [
          "https://www.facebook.com/psprcmus",
          "https://www.instagram.com/psprcmus/",
          "https://www.pinterest.com/psprcmus/",
        ],
        areaServed: {
          "@type": "Country",
          name: "United States",
        },
        knowsAbout: [
          "Medical Billing",
          "Medical Coding",
          "Denial Management",
          "Revenue Cycle Management",
          "Credentialing & Enrollment",
        ],
      },
    },
    createBreadcrumbSchema("/about-us", "About Physicians Success Partners"),
  ],
};

export default function About() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/about-us"
        schema={seo.schema}
      />
      <BannerComp
        heading="Strategic Medical Billing Partnerships to Maximize Revenue & RCM Performance"
        paragraph="With over 20 years of expertise in Revenue Cycle Management (RCM), we help healthcare providers improve cash flow, reduce claim denials, and streamline billing operations for stronger financial performance and sustainable growth."
        BannerBgImg="/pages-banner.webp"
        form={true}
        pageType="about"
      />
      <PartnerSliderComp />
      <Section1 />
      {/* <Section2 /> */}
      <ServiceCTASection
        imageSrc="/img/services-img/cta-section-img.webp"
        title="Dedicated Billing Consultant for Your Clinic’s RCM"
        description="Medical billing can be prone to errors, delays, and inefficiencies that affect your cash flow and profitability. PSP RCM's billing associates streamline your clinic’s billing process by taking care of the entire RCM with real-time reports and analytics."
      />
      <Section3 />
      <Section4 />
      <SpecialCardSection
        items={specialties}
        variant="list"
        heading="Revenue Cycle Management for Multi-Specialty Healthcare Providers"
        description="We deliver expert Revenue Cycle Management (RCM) solutions to over 200+ specialized healthcare providers across cardiology, podiatry, neurology, urology, pediatrics, pain management, and other specialties. Our comprehensive expertise covers every aspect of the revenue cycle, helping providers improve billing accuracy, reduce denials, and maximize reimbursement efficiency."
      />
      <Section5 />
      <Section6 />
    </>
  );
}
